import React from 'react';
import { Header, Footer, Form } from '../components/common';
import { About as AboutSection, FoundersAchievement, Vision } from '../components/homepage';
import { homePageContent } from '../content/homePage';
import { useContactForm } from '../utils/contactForm';
import '../components/common/PageLayout.css';

const { form, foundersAchievement } = homePageContent;

const About = () => {
  const { submitStatus, handleSubmit, errorMessage } = useContactForm();

  return (
  <>
    <div className="hero-gradient-wrap">
      <Header ctaText="Join Community" ctaPath="#courses" />
      <section className="page-hero">
        <h1>About Us</h1>
        <p>We help individuals and organizations build skills that matter through AI-powered learning and industry-aligned tracks.</p>
      </section>
    </div>
    <main className="page-layout-main">
      {/* <AboutSection /> */}
      <Vision />
      <FoundersAchievement title={foundersAchievement.title} subtitle={foundersAchievement.subtitle} />
      <Form
        title={form.title}
        subtitle={form.subtitle}
        onSubmit={handleSubmit}
        submitStatus={submitStatus}
        errorMessage={errorMessage}
      />
    </main>
    <Footer />
  </>
  );
};

export default About;
